import { connect } from 'react-redux'
// import './layout.scss'
// import './reset.scss'
// import './style.scss'

const mapDispatchToProps = {

}

const mapStateToProps = (state) => ({
  login: state.login,
})

import React, { Component } from 'react'
import { IndexLink, Link, hashHistory, browserHistory } from 'react-router'
import AppBar from 'material-ui/AppBar'
import IconButton from 'material-ui/IconButton'
import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import FlatButton from 'material-ui/FlatButton'
import Toggle from 'material-ui/Toggle'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import NavigationClose from 'material-ui/svg-icons/navigation/close'
import SignOut from 'material-ui/svg-icons/action/exit-to-app'
import Help from 'material-ui/svg-icons/action/help'
import SettingsIcon from 'material-ui/svg-icons/action/settings'
import LeftNav from '../LeftNav/LeftNav'
import Header from '../../components/Header'

class TopMenuBar extends Component {
  state = {
    logged: true,
    drawerOpen: false
  };

  _handleToggle = () => this.setState({ drawerOpen: !this.state.drawerOpen });

  _selectMenu = (target) => {
    this.setState({ drawerOpen: false })

    if (target.match(/^https?:/)) {
      document.location.href = target
    } else {
      hashHistory.push(target)
    }
  }

  _requestChange = (open, reason) => {
    this.setState({ drawerOpen: open })
  }

  render () {
    return (
      <Header/>

    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TopMenuBar)



// WEBPACK FOOTER //
// ./src/layouts/TopMenuBar/TopMenuBar.js